// WLC-specific localStorage key constants.
// Prefixed with 'wlc_rtc_' to avoid collisions with other provider screening pages
// (Phoenix, PsychConsultations) that share the same domain.
//
// All keys are bulk-cleared on successful form submission and on the dev/QA "Reset"
// button (see AdhdScreeningWLC.js clearStoredData). Adding a new key here automatically
// enrolls it in that cleanup.

export const STORAGE_KEYS = {
    // Form progress state
    CURRENT_QUESTION: 'wlc_rtc_current_question',
    SUBMITTED_ANSWERS: 'wlc_rtc_submitted_answers',
    IS_COMPLETE: 'wlc_rtc_is_complete',
    CURRENT_FORM_DATA: 'wlc_rtc_current_form_data',
    WELCOME_COMPLETE: 'wlc_rtc_welcome_complete',

    // Funnel tracking: anonymous session UUID that ties all events from a single
    // form attempt together. Generated once at form_start, reused for all subsequent
    // events, destroyed on submission or reset.
    SESSION_ID: 'wlc_rtc_session_id',

    // Funnel tracking: dedup flags. Each flag is set to 'true' after the corresponding
    // event has been fired to prevent duplicate writes on page refresh or re-navigation.
    FORM_START_LOGGED: 'wlc_rtc_form_start_logged',
    SCREENING_COMPLETE_LOGGED: 'wlc_rtc_screening_complete_logged',
    THRESHOLD_NOT_MET_LOGGED: 'wlc_rtc_threshold_not_met_logged',
    PERSONAL_STARTED_LOGGED: 'wlc_rtc_personal_started_logged',

    // Funnel tracking: JSON bag of already-fired step_* events for this attempt.
    // Keys look like "step_viewed:asrs_1" / "step_completed:welcome_0". Cleared on
    // successful submit or Reset so a new attempt starts with a clean slate.
    STEP_EVENTS_LOGGED: 'wlc_rtc_step_events_logged',
};
